<script setup lang="ts">
type Nav = {
  text: string;
  to: string;
  external?: boolean;
  newWindow?: boolean;
};

const navItems: Nav[] = [
  {
    text: 'トップ',
    to: '/',
  },
  {
    text: 'ニュース',
    to: '/public/article/news',
  },
  {
    text: 'ダイエットレシピ',
    to: '/public/article/recipe/top',
  },
  {
    text: 'Dietアプリ',
    to: '/s/service_dietplus',
    newWindow: true,
  },
];
</script>

<template>
  <header
    class="max-w-content-width mx-auto py-2 justify-between items-center md:flex hidden"
  >
    <div class="shrink-0 pt-2">
      <NuxtLink to="/"><AtomsDietPlusLogo class="w-[208px] mr-20" /></NuxtLink>
    </div>
    <ul class="flex justify-end grow pt-2 gap-3">
      <li
        v-for="nav in navItems"
        :key="nav.to"
        class="[&:not(:first-child)]:border-l border-gray-300 pl-3"
      >
        <NuxtLink
          :to="nav.to"
          :external="nav.external"
          class="font-bold hover:text-gray-500 hover:underline underline-offset-4 decoration-2 text-gray-500"
          :target="nav.newWindow ? '_blank' : undefined"
          :rel="nav.newWindow ? 'noopener' : undefined"
          >{{ nav.text }}</NuxtLink
        >
      </li>
    </ul>
  </header>
</template>
